import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { LanguageService } from '../../services';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  imgurl: string = '../../assets/backgrounds/banquise_1.jpg';

  english: boolean;

  // *** Content *** //

  title: string;
  slogan: string;

  mobileDescription: string;
  webDescription: string;

  // *** Swiper *** //

  public mobileConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    autoplay: {
      delay: 6000
    },
    slideToClickedSlide: true,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: {
      nextEl: '.mobile-button-next',
      prevEl: '.mobile-button-prev',
    },
    pagination: false,
    effect: 'coverflow',
    grabCursor: true,
    spaceBetween: 40,
    coverflowEffect: {
      rotate: 40,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    centeredSlides: true,
    initialSlide: 1
  };

  public mobileSlides = [
    {
      url: '../../../assets/swiper/mobile1.jpg',
      description: 'Téléchargez l\'application Lookar sur les stores'
    },
    {
      url: '../../../assets/swiper/mobile2.jpg',
      description: 'Prenez en photo une voiture avec Lookar'
    },
    {
      url: '../../../assets/swiper/mobile3.jpg',
      description: 'Identification de la marque et du modèle'
    }
  ];

  public webConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    autoplay: {
      delay: 6000
    },
    slideToClickedSlide: true,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: {
      nextEl: '.web-button-next',
      prevEl: '.web-button-prev',
    },
    pagination: false,
    effect: 'coverflow',
    grabCursor: true,
    spaceBetween: 40,
    coverflowEffect: {
      rotate: 40,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    centeredSlides: true,
    initialSlide: 0
  };

  public webSlides = [
    {
      url: '../../../assets/swiper/web1.jpg',
      description: 'Publiez vos produits de référence'
    },
    {
      url: '../../../assets/swiper/web2.jpg',
      description: 'Nous recherchons votre contenu sur le web'
    },
    {
      url: '../../../assets/swiper/web3.png',
      description: 'Nous retrouvons votre contenu'
    }
  ];

  // ***************************** //

  constructor(private titleService: Title, private languageService: LanguageService) { }

  ngOnInit() {
    this.titleService.setTitle('eyeSnap')
    this.initContent();
  }

  onLanguage() {
    this.initContent();
  }

  // *** Content *** //

  initContent() {
    this.languageService.getLanguage()
      .subscribe(english => this.english = english);
    if (this.english) {
      this.title = 'Make Images Talk!';
      this.slogan = 'Artificial Intelligence for image';
      this.mobileDescription = 'With eyeSnap Mobile, the physical world becomes interactive through a simple photo. eyeSnap-Mobile is a natural link between physical objects and digital content.';
      this.webDescription = 'eyeSnap Tracker quickly finds on the web the images visually similar to your visual assets.';
    } else {
      this.title = 'Faire Parler les Images!';
      this.slogan = 'L\'Intelligence Artificielle au service de l\'image';
      this.mobileDescription = 'eyeSnap permet d’accéder à une information en 1 photo !';
      this.webDescription = 'eyeSnap automatise une recherche d’information ciblée sur de gros volumes d\'images';
    }
  }

}
